import React from 'react'

const Button = props => (
  <p
    className={props.addClass ? 'pointer ' + props.addClass : 'pointer'}
    onClick={props.clicked ? props.clicked : ''}
  >
    {props.text}
  </p>
)

export default Button
